import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../../lib/utils';

const linkClass = (active, justifyCenter) =>
  cn(
    'flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors relative w-full',
    justifyCenter && 'justify-center',
    active
      ? 'bg-primary/15 text-primary'
      : 'text-[#a0a0a0] hover:text-white hover:bg-white/[0.04]',
  );

const isPathActive = (item, pathname) => {
  if (!item?.path) return false;
  const path = `/${item.path}`;
  if (item.exact) return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
};

const NavItem = ({ item, collapsed }) => {
  const location = useLocation();
  const active = isPathActive(item, location.pathname);
  const Icon = item.icon;

  return (
    <li>
      <NavLink
        to={`/${item.path}`}
        title={collapsed ? item.name : undefined}
        className={linkClass(active, collapsed)}>
        {active ? (
          <span className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-5 bg-primary rounded-r" />
        ) : null}
        {Icon ? <Icon className="w-4 h-4 flex-shrink-0" /> : null}
        {!collapsed && <span className="truncate">{item.name}</span>}
      </NavLink>
    </li>
  );
};

export default NavItem;
